import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import {Message, MessageBox} from 'element-ui'
import fanyi from '../utlis/language'

Vue.use(VueRouter)

const routes = [
  /* 用户页面*/
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/UserCenter/index.vue'),
    meta: {
      requireAuth: true,
    },
    children: [
      // 用户-首页
      {
        path: '/user/index',
        name: 'userIndex',
        component: () =>
          import('../views/UserCenter/views/UserIndex/index.vue'),
        meta: {
          // 标题，标题描述
          tagtitle: 'Личный кабинет',
          requireAuth:true,
        },
      },
      // 用户-订单页面
      {
        path: '/user/order',
        name: 'userOrder',
        component: () =>
          import('../views/UserCenter/views/userOrder/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Все заказы',
        },
      },

      // 用户-问题产品
      {
        path: '/user/faultyproducts',
        name: 'faultyproducts',
        component: () =>
          import('../views/UserCenter/views/issueOrder/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Бракованные товары',
        },
      },

      // 用户-运输中页面 
      {
        path: '/user/packinglist',
        name: 'packinglist',
        component: () =>
          import('../views/UserCenter/views/deliveryList/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Упаковочный лист',
        },
      },
      // 用户仓库页面
      {
        path: '/user/Warehouse',
        name: 'Warehouse',
        component: () =>
          import('../views/UserCenter/views/warehouse/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Склад',
        },
      },

      // 用户-充值记录页面
      {
        path: '/user/paymentsummary',
        name: 'paymentsummary',
        component: () =>
          import('../views/UserCenter/views/churujinList/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Детализация счета',
        },
      },
      // 用户-提现记录页面
      {
        path: '/user/WithdrawalRecord',
        name: 'WithdrawalRecord',
        component: () =>
          import(
            '../views/UserCenter/views/churujinList/views/WithdrawalRecord.vue'
          ),
          meta: {
            requireAuth: true,     tagtitle: 'Вывод средств',
          },
      },
      // 用户-收藏夹产品页面
      {
        path: '/user/favoriteproducts',
        name: 'favoriteproducts',
        component: () =>
          import('../views/UserCenter/views/collection/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Избранные товары',
        },
      },
      // 用户-收藏夹商店页面
      {
        path: '/user/favoriteshops',
        name: 'favoriteshops',
        component: () =>
          import('../views/UserCenter/views/favoritec/index.vue'),
        meta: {
            requireAuth: true,
            tagtitle: 'Избранные магазины',
          },
      },

      // 用户-收藏夹商品库列表页面
      {
        path: '/user/productlibrary',
        name: 'productlibrary',
        component: () =>
          import('../views/UserCenter/views/commodity/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Каталог товаров',
        },
      },
      // 用户-登录信息页面
      {
        path: '/user/userDetail',
        name: 'userDetail',
        component: () =>
          import('../views/UserCenter/views/userDetail/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Изменить личные данные',
        },
      },
      // 用户-编辑地址页面
      {
        path: '/user/addressmanagement',
        name: 'addressmanagement',
        component: () =>
          import('../views/UserCenter/views/deliverySite/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Управление адресами',
        },
      },
      // 提现页面
      // {
      //   path: '/user/withdrawal',
      //   name: 'withdrawDeposit',
      //   component: () => import('../views/UserCenter/views/withdrawDeposit/index.vue'),
      //   meta: {
      //     requireAuth: true,
      //     tagtitle: 'Вывод средств',
      //   },
      // },

      // 用户-更改密码页面
      {
        path: '/user/changepassword',
        name: 'changepassworld',
        component: () =>
          import('../views/UserCenter/views/changepassworld/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Поменять пароль',
        },
      },
      // 用户-优惠券
      {
        path: '/user/coupon',
        name: 'coupon',
        component: () => import('../views/UserCenter/views/coupon/index.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Купон',
        },
      },

      // 用户-通知
      {
        path: '/user/inform',
        name: 'inform',
        component: () => import('../views/UserCenter/views/inform/idnex.vue'),
        meta: {
          requireAuth: true,
          tagtitle: 'Уведомление',
        },
      },
    ],
  },
  // 首页
  {
    path: '/',
    name: 'homepage',
    component: () => import('../views/homepage/index.vue'),
    meta: {
      // 标题，标题描述
      tagtitle: 'Sponlax - Лучший партнер по закупке и импорту китайских товаров',
      tagdescription: "Мы предоставим вам на выбор десятки тысяч поставщиков, вы сможете выбрать то, что вам нужно, на крупнейшем в мире рынке оптовых поставок.",
    },
  },
  // 用户-问题产品详情
  {
    path: '/faultyproductsOrderDetail',
    name: 'faultyproductsOrderDetail',
    component: () =>
      import('../views/UserCenter/views/issueOrder/views/issueOrderDetail.vue'),
    meta: {
      requireAuth: true,
      tagtitle:'Детали заказа на товары с дефектом',
    },
  },
  // 订单页面
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: () =>
      import('../views/UserCenter/views/userOrder/views/OrderDetails.vue'),

    meta: {
      requireAuth: true,
      tagtitle: 'Детали заказа',
      temporary: 'Оформить заказ',// 临时保存
      offer:"Заказы котироваться",//待报价
      obligation: 'Заказ ожидает оплаты',// 代付款
      purchase: 'Заказ в процессе закупки',// 购买中
    purchased: 'Покупка завершена',//购买完成
    warehouse:"Заказ выполнен",//上架完了
      

    },
    
  },

  // 商品详情
  {
    path: '/productDetails',
    name: 'productDetails',
    component: () => import('../views/productDetail/index.vue'),
    meta: {},
  },
  // 店铺商品
  {
    path: '/shopGoods',
    name: 'shopGoods',
    component: () => import('../views/shopGoods/index.vue'),
  },
  // 忘记密码页面
  {
    path: '/forgetThePassword',
    name: 'ForgetThePassword',
    component: () => import('../views/ForgetThePassword/index.vue'),
  },
  /* 注册页面*/
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register/index.vue'),
    meta: {
      tagtitle: 'Регистрация',
    },
  },
  /* 登录页面*/
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      title: 'Войти',
    },
  },

  /* 购物车列表*/
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/cart/index.vue'),
    meta: {
      requireAuth: true,
      tagtitle: 'Корзина',
    },
  },

  /* 订单支付*/
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../views/payment/index.vue'),
    meta: {
      tagtitle: 'Платёжный интерфейс',
      requireAuth: true,
    },
  },
  // paypal 支付失败

  {
    path: '/paypalPaymentError',
    name: 'paypalPaymentError',
    component: () => import('../views/paypalPaymentError/index.vue'),
    meta: {
      // tagtitle: 'Sponlax payment interface',
    },
  },
  /* 商品搜索页*/
  {
    path: '/commoditySearch',
    name: 'commoditySearch',
    component: () => import('../views/CommoditySearch/index.vue'),
 
  },

  //平台自营

  {
    path: '/platformselOperation',
    name: 'platformselOperation',
    component: () => import('../views/platformselOperation/index.vue'),
    meta: {
      // title: 'Sponlax - Outdoor Sports Products',
    },
  },
  // 热销品类 
  {
    path: '/hotsellingcategory',
    name: 'hotsellingcategory',
    component: () => import('../views/hotsellingcategory/index.vue'),
    meta: {
      // title: 'Sponlax - Outdoor Sports Products',
    }
  },
  /* 隐私政策*/
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () =>
      import(/* webpackChunkName: "foot" */ '../views/footList/privacyPolicy'),
    meta: {
      tagtitle: 'Sponlax - Политика конфиденциальности',
      tagdescription: 'Sponlax - Политика конфиденциальности',
    },
  },
  /* 摄影服务*/
  {
    path: '/photography-services',
    name: 'PhotographyServices',
    component: () =>
      import(
        /* webpackChunkName: "foot" */ '../views/footList/PhotographyServices'
      ),
  },

  /* 服务条款*/
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    component: () =>
      import(/* webpackChunkName: "foot" */ '../views/footList/termsService'),
    meta: {
      tagtitle: 'Sponlax - Общие положения',
      tagdescription: 'Sponlax - Общие положения',
    },
  },
  /* option，附加服务*/
  {
    path: '/additional-services',
    name: 'Additional services',
    component: () =>
      import(/* webpackChunkName: "foot" */ '../views/footList/option'),
    meta: {
      tagtitle: 'Дополнительные услуги',
      tagdescription:
        'Sponlax предлагает ряд дополнительных услуг для улучшения вашего опыта, включая маркировку FBA, фотосъемку продукции, настройку ODM, перевод и многое другое',
    },
  },

  /* 公司介绍*/
  {
    path: '/company-introduction',
    name: 'company-introduction',
    component: () =>
      import(/* webpackChunkName: "foot" */ '../views/footList/introduction'),
  },
  /* 关于我们*/
  {
    path: '/about-sponlax',
    name: 'about-sponlax',
    component: () =>
      import(
        /* webpackChunkName: "foot" */ '../views/footList/aboutsponlax.vue'
      ),
    meta: {
      tagtitle: 'О нас',
      tagdescription:
        'Оптимизируйте процесс закупок и импорта в Китай, оптимизируя расходы. Позвольте нам сделать все за вас.',
    },
  },


  // 用户指南
  {
    path: '/user-guide',
    name: 'userGuide',
    component: () => import('../views/footList/userGuide.vue'),
    meta: {
      tagtitle: 'Руководство пользователя',
    },
  },
  /* 常见问题*/
  {
    path: '/faq',
    name: 'faq',
    component: () =>
      import(/* webpackChunkName: "foot" */ '../views/footList/frequentlyaskedquestions.vue'),
    meta: {
      tagtitle: 'ЧаВо',
    },
  },

  /*佣金*/
  {
    path: '/commission',
    name: 'commission',
    component: () =>
      import(
        /* webpackChunkName: "committee" */ '../views/footList/Committee.vue'
      ),
    meta: {
      tagtitle: 'Комиссия',
    },
  },
  
  // /* 国际运费*/
  {
    path: '/international-freight',
    name: 'international-freight',
    component: () =>
      import(
        /* webpackChunkName: "foot" */ '../views/footList/international_freight.vue'
      ),
    meta: {
      tagtitle:
        'Международная логистика',
      tagdescription:
        "Воспользуйтесь обширными ресурсами и услугами Sponlax, чтобы изменить способ совершения покупок и импорта из Китая.",
    },
  },

  /*配送单详情*/
  {
    path: '/deliveryDetails',
    name: 'deliveryDetails',
    component: () =>
      import(
        '../views/UserCenter/views/deliveryList/views/DeliveryDetails/index.vue'
      ),
      meta: {
        requireAuth: true,
        tagtitle:
        'Детали упаковочного листа',
      },
  },

  // 注册成功
  {
    path: '/registeredSuccess',
    name: 'registeredSuccess',
    component: () => import('../views/register/view/registeredSuccess.vue')
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {

  return originalPush.call(this, location).catch((err) => err)
}

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
})
let logPath = () => {
  let data = []
  routes.forEach((element1) => {
    data.push(element1.path)
    if (element1.children && element1.children.length != 0) {
      element1.children.forEach((element2) => {
        data.push(element2.path)
      })
    }
  })
  return data
}
let pcddd = logPath()

let Changeroutertitle = (to) => {
  // 进行判断动态添加title
  let metacontent = document.querySelector('#metacontent')
  // 如果有标题就用标题 ，没有就直接Sponlax+用路由名
  if (to.meta.tagtitle) {
    document.title = to.meta.tagtitle
  } 
  if (to.meta.tagdescription) {
    metacontent.content = to.meta.tagdescription
  } else {
    metacontent.content = ''
  }
  if (to.name == 'productDetails') {
    return
  }
  // 搜索页单独设置
  if (to.path == '/commoditySearch') {
    //  如果是搜索也就展示搜索标题
    var reg = /[a-z]/ //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/

    if (
      to.query.type != 'imgSearch' &&
      reg.test(to.query.keyword.slice(0, 1))
    ) {
      var keyWordsstr =
        to.query.keyword.slice(0, 1).toUpperCase() + to.query.keyword.slice(1)
    } else {
      var keyWordsstr = to.query.keyword
    }
    document.title =
     (to.query.imgUrl ? 'Поиск по картинкам' : keyWordsstr)
    metacontent.content = ''
  }
  // 订单详情多种情况
  if (to.path == '/orderDetails') {
     // //       tagtitle: 'Order Details',
    
    // if (to.query.type == 'temporary') {
    //   document.title = to.meta.temporary
    //   metacontent.content = ''
    //   return
    // }
    // if (to.query.type == 'offer') {
    //   document.title = to.meta.offer
    //   metacontent.content = ''
    //   return
    // }
    // if (to.query.type == 'obligation') {
    //   document.title = to.meta.obligation
    //   metacontent.content = ''
    //   return
    // }
    // if (to.query.type == 'purchase') {
    //   document.title = to.meta.purchase
    //   metacontent.content = ''
    //   return
    // }
    // if (to.query.type == 'purchased') {
    //   document.title = to.meta.purchased
    //   metacontent.content = ''
    //   return
    // }
    // if (to.query.type == 'warehouse') {
    //   document.title = to.meta.warehouse
    //   metacontent.content = ''
    //   return
    // }
   
    document.title = to.meta.tagtitle
    metacontent.content = ''
  }
  // 配送单详情多种情况
  if (to.path == '/deliveryDetails') {

    if (to.query.status) {
       // 待报价 ： [20,22]
      // 待支付 ：30
      // 待发货配送单 : [40,53]
      // 运输中配送单 : 60
      // 俄罗斯派送配送单 ： [64, 70)
      // 已签收 70
  
      // // 待报价
      // if (Number(to.query.status) >= 20 && Number(to.query.status) <= 22) {
      //   document.title = 'Заказы котироваться'
      // }
      //     // 待支付
      // if (Number(to.query.status) == 30) {
      //   document.title='Ожидание платеж'
      // }
      // // 待发货配送单
      // if (Number(to.query.status) >= 40 && Number(to.query.status) <= 53) {
      //   document.title = 'Упаковочный лист'
      // }
      // // 运输中配送单
      // if (Number(to.query.status) == 60) {
      //    document.title='Упаковочный лист '
      // }
      // // 俄罗斯派送配送单
      // if (Number(to.query.status) >= 64 && Number(to.query.status) < 70) {
      //    document.title = 'Доставка по России'
      // }
      // // 已签收
      // if (Number(to.query.status) == 70) {
      //   document.title ='Подтверждение доставки'
      // }
      
    }
    metacontent.content = ''
  }

}

let urlOrigin = location.origin
let openLogin = function (to) {
  // store.commit('getshowLoginDialog', true)//打开登录弹窗

  MessageBox.confirm(fanyi('登录失效,是否前往登录?'), fanyi('提示'), {
    confirmButtonText: fanyi('登录'),
    cancelButtonText: fanyi('取消'),
    customClass: 'message-login',// 自定义类名
  }).then(() => {
    location.href = urlOrigin + '/login'
  }).catch(() => {
    location.href = urlOrigin + '/'
  });


}
// 白名单不需要登录
let Whitelist = ['/','/productDetails','/shopGoods','/forgetThePassword','/register','/login','/commoditySearch','/platformselOperation','/hotsellingcategory','/privacypolicy','/photography-services','/terms-of-service','/additional-services','/company-introduction','/about-sponlax','/user-guide','/faq','/commission','/video-maintenance','/international-freight','/registeredSuccess']
router.beforeEach((to, from, next) => {  
  // 先判断有没有
  if (to.query.token) {
    sessionStorage.setItem('russia_user_token', to.query.token)
  }

  
  // 先判断
  if (sessionStorage.getItem('russia_user_token')) {
     // 判断如果有token 没有登录信息时候去获取用户信息
     if (store.state.userInfo == null) {
      Vue.prototype.$api.EuropegetUserInfo().then((res) => {
        // 登录失效
  
        console.log(res);
        
        if (res.code != 0) {
          store.commit('userData', null)
          sessionStorage.removeItem('russia_user_token')
          // 如果token没用 判断是不是需要登录权限，如果需要提醒用户登录
          if (to.matched.some((record) => record.meta.requireAuth)) {
            openLogin(to)

          }
          return
        } else {
          // 如果没问题放行，存储用户信息
          store.commit('userData', res.data) // 用户信息存储
          next()
        }
      })
    } else {
      next()
    }
  } else {
    if (localStorage.getItem('russia_user_token')) {
      // 判断如果有token 没有登录信息时候去获取用户信息
      if (store.state.userInfo == null) {
        Vue.prototype.$api.EuropegetUserInfo().then((res) => {
          // 登录失效
          if (res.code != 0) {
            store.commit('userData', null)
            localStorage.removeItem('russia_user_token')
            // 如果token没用 判断是不是需要登录权限，如果需要提醒用户登录
            if (to.matched.some((record) => record.meta.requireAuth)) {
              openLogin(to)
  
            }
            return
          } else {
            // 如果没问题放行，存储用户信息
            store.commit('userData', res.data) // 用户信息存储
            next()
          }
        })
      } else {
        next()
      }
  
    } else {    
      if (to.matched.some((record) => record.meta.requireAuth)) {   // 如果不需要token
      // 判断该路由是否需要登录权限
        openLogin(to)
      } else {
        next()
      }
    }
  }

  // 判断路由动态添加titie
  Changeroutertitle(to)
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
export default router
